/**
 * Cleans player URLs by removing the base path that the API returns
 * The API returns URLs like: /cgi-bin/WebObjects/nuLigaTTCH.woa/wa/playerPortrait?...
 * But we only need: playerPortrait?...
 *
 * This works for both playerPortrait and eloFilter URLs (though we prefer playerPortrait)
 */
export const cleanPlayerUrl = (url: string): string => {
  if (!url) return url;

  const basePath = '/cgi-bin/WebObjects/nuLigaTTCH.woa/wa/';

  // Remove base path if present
  if (url.startsWith(basePath)) {
    return url.substring(basePath.length);
  }

  // Also handle case where leading slash is already removed
  const basePathWithoutSlash = basePath.substring(1);
  if (url.startsWith(basePathWithoutSlash)) {
    return url.substring(basePathWithoutSlash.length);
  }

  // Handle URLs that already have leading slash removed and no base path
  // Just remove the leading slash if present
  if (url.startsWith('/') && !url.startsWith(basePath)) {
    return url.substring(1);
  }

  return url;
};
